var map = {
	"./HAIR1.svg": 97099,
	"./HAIR10.svg": 78878,
	"./HAIR11.svg": 40773,
	"./HAIR12.svg": 73076,
	"./HAIR2.svg": 64144,
	"./HAIR3.svg": 10335,
	"./HAIR4.svg": 58845,
	"./HAIR5.svg": 22006,
	"./HAIR6.svg": 5816,
	"./HAIR7.svg": 58935,
	"./HAIR8.svg": 48614,
	"./HAIR9.svg": 18303
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21642;